import React, { forwardRef } from "react";
import { Col, Row } from "react-bootstrap";
import { getFullNameUser, numberWithCommas } from "../../Helpers/Utils/Common";

const CategoryPdf = forwardRef((props, ref) => {
  return (
    <div ref={ref} className="p-2">
      <Row>
        <label className="print-text">
          {props.restoType
            ? props.restoType === "dreamnest"
              ? "DREAMNEST"
              : "ETTAS"
            : ""}
        </label>
      </Row>
      <Row>
        <label className="print-text">{window.company_address}</label>
      </Row>
      <Row>
        <label className="print-text">
          DATE FROM: {props.filter.date_from}
        </label>
      </Row>
      <Row>
        <label className="print-text">DATE TO: {props.filter.date_to}</label>
      </Row>
      <Row>
        <label className="print-text">CASHIER: {getFullNameUser()}</label>
      </Row>
      {/* to be condition if button clicked is hourly print category sales report else daily or hourly*/}
      <Row>
        <Col className="d-flex justify-content-start mt-3">
          <h5>
            <strong>
              {props.title ? props.title : "Category "} Sales Report
            </strong>
          </h5>
        </Col>
        <hr />
      </Row>
      {props.data2.map((data) => {
        return (
          <Row key={data.name}>
            {data.items && data.items.length > 0 && (
              <>
                <Col>
                  <strong>{data.name.toUpperCase()}</strong>
                </Col>
                {props.tab && props.tab === "resto" && (
                  <Col className="d-flex justify-content-center">ITEM CODE</Col>
                )}
                <Col className="d-flex justify-content-center">QTY</Col>
                <Col className="d-flex justify-content-end">
                  Total Sales :{" "}
                  {numberWithCommas(
                    data.items && data.items.length > 0
                      ? data.items
                          .map((item) => parseFloat(item.total_amount))
                          .reduce((a, b) => a + b, 0)
                          .toFixed(2)
                      : "0.00"
                  )}
                </Col>
                {data.items &&
                  data.items.map((item) => (
                    <Row key={item.menu_name} className="ms-2">
                      <Col>{item.menu_name}</Col>
                      {props.tab && props.tab === "resto" && (
                        <Col>{item.item_code}</Col>
                      )}
                      <Col className="d-flex justify-content-center ">
                        {item.total_qty}
                      </Col>
                      <Col className="d-flex justify-content-end">
                        {numberWithCommas(item.total_amount)}
                      </Col>
                    </Row>
                  ))}
              </>
            )}
          </Row>
        );
      })}
      <Row className="pt-3">
        <Col>
          <label className="print-text">
            <strong>Subtotal:</strong>
          </label>
        </Col>
        <Col className="d-flex justify-content-end print-text">
          <label>
            <strong>{props.totals.subtotal}</strong>
          </label>
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="print-text">
            <strong>B1T1 Discount:</strong>
          </label>
        </Col>
        <Col className="d-flex justify-content-center print-text"></Col>
        <Col className="d-flex justify-content-end print-text">
          <label>
            <strong>{props.totals.less_discount}</strong>
          </label>
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="print-text">
            <strong>Grand Total:</strong>
          </label>
        </Col>
        <Col className="d-flex justify-content-center print-text"></Col>
        <Col className="d-flex justify-content-end print-text">
          <label>
            <strong>{props.totals.grand_total}</strong>
          </label>
        </Col>
      </Row>
    </div>
  );
});

export default CategoryPdf;
